import React  from 'react'
import { useSelector } from 'react-redux'

import alertModal from './AlertModal'

import createProjectModal from './CreateProjectModal'
import deleteProjectModal from './DeleteProjectModal'
import cloneProjectModal from './CloneProjectModal'

import createProjectunitModal from './CreateProjectunitModal'
import editProjectunitModal from './EditProjectunitModal'
import deleteProjectunitModal from './DeleteProjectunitModal'
import cloneProjectunitModal from './CloneProjectunitModal'

import saveProductSystemItemsModal from './SaveProductSystemItemsModal'

import editProductSolutionModal from './EditProductSolutionModal'
import deleteProductSolutionModal from './DeleteProductSolutionModal'

import deactivateProjectModal from './DeactivateProjectModal'
import reactivateProjectModal from './ReactivateProjectModal'

import showDatenschutzModal from './ShowDatenschutzModal'
import showTermsOfUseModal from './ShowTermsOfUseModal'

import showWizardInfoModal from './ShowWizardInfoModal'

import catchUnauthorizedSaveSolutionModal from './CatchUnauthorizedSaveSolutionModal'

import editProjectSolutionMetadataModal from './EditProjectSolutionMetadataModal'

import showDownloadRevitErrorModal from './ShowDownloadRevitErrorModal'

const ModalContainer = (props) => {

  const MODALS = {
    'MODAL_ALERT': alertModal,

    'MODAL_CREATE_PROJECT':  createProjectModal,
    'MODAL_DELETE_PROJECT': deleteProjectModal,
    'MODAL_CLONE_PROJECT': cloneProjectModal,

    'MODAL_CREATE_PROJECTUNIT': createProjectunitModal,
    'MODAL_EDIT_PROJECTUNIT': editProjectunitModal,
    'MODAL_DELETE_PROJECTUNIT': deleteProjectunitModal,
    'MODAL_CLONE_PROJECTUNIT': cloneProjectunitModal,

    'MODAL_SAVE_PRODUCT_SYSTEM_ITEMS': saveProductSystemItemsModal,

    'MODAL_EDIT_PRODUCT_SOLUTION': editProductSolutionModal,
    'MODAL_DELETE_PRODUCT_SOLUTION': deleteProductSolutionModal,

    'MODAL_DEACTIVATE_PROJECT': deactivateProjectModal,
    'MODAL_REACTIVATE_PROJECT': reactivateProjectModal,

    'MODAL_CATCH_UNAUTHORIZED_SAVE_SOLUTION': catchUnauthorizedSaveSolutionModal,

    'MODAL_SHOW_DATENSCHUTZ': showDatenschutzModal,
    'MODAL_SHOW_TERMS_OF_USE': showTermsOfUseModal,

    'MODAL_EDIT_PROJECT_SOLUTION_METADATA': editProjectSolutionMetadataModal,

    'MODAL_SHOW_WIZARD_INFO': showWizardInfoModal,

    'MODAL_DOWNLOAD_REVIT_ERROR': showDownloadRevitErrorModal

  }

  const modalType = useSelector(state => state.modal.modalType)
  const formObject = useSelector(state => state.modal.modalProps.formObject)

  if (!modalType) {
    return null
  }
  const SpecifiedModal = MODALS[modalType]
  return <SpecifiedModal formObject={formObject}/>
}

export default ModalContainer



// WEBPACK FOOTER //
// ./src/components/Modals/ModalRoot.js